import * as React from "react";
import styles from "./Binary.module.scss";

export type Props = {
  value: string[];
};
const Binary = (props: Props): JSX.Element => (
  <div className={styles.binary}>
    {props.value.map((item: string, index: number) => (
      <span key={index} className={styles.bit}>
        {item}
      </span>
    ))}
  </div>
);

export default Binary;
